import { PermissionFlagName } from 'lib/types';

export interface IAdminTab {
    title: string;
    pathSuffix: string;
    permissionKey: PermissionFlagName;
}

export const ADMIN_TABS: IAdminTab[] = [
    { title: 'Administratorzy', pathSuffix: 'admins', permissionKey: 'canManageAdmins' },
    { title: 'Prace serwisowe', pathSuffix: 'service-works', permissionKey: 'canManageServiceWorks' },
    { title: 'Wyniki testów', pathSuffix: 'test-results', permissionKey: 'canViewTests' },
    { title: 'Grafiki asortymentu', pathSuffix: 'assortment-graphics', permissionKey: 'canManageAssortmentImages' },
    { title: 'Aktualności', pathSuffix: 'news', permissionKey: 'canManageNews' },
    { title: 'Cache', pathSuffix: 'cache-management', permissionKey: 'canManageCache' },
    { title: 'Statystyki', pathSuffix: 'statistics', permissionKey: 'canViewStatistics' },
    { title: 'Baza kodów pocztowych', pathSuffix: 'postals', permissionKey: 'canUpdatePostals' },
    { title: 'Instrukcja zamówień online', pathSuffix: 'online-orders-manual', permissionKey: 'canEditManual' }
];
